import React from 'react';
import './ThemeCustomizer.css';

const fonts = [
  'Arial', 'Times New Roman', 'Helvetica', 'Georgia', 'Verdana',
  'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Inter', 'Calibri', 'Garamond'
];

const fontSizes = ['12px', '13px', '14px', '15px', '16px', '18px'];

const colorPresets = [
  { name: 'Classic Blue', primary: '#2c3e50', accent: '#3498db' },
  { name: 'Modern Teal', primary: '#1a1a2e', accent: '#06b6d4' },
  { name: 'Forest', primary: '#1a3c34', accent: '#10b981' },
  { name: 'Sunset', primary: '#2d1b69', accent: '#f59e0b' },
  { name: 'Crimson', primary: '#2c0e0e', accent: '#ef4444' },
  { name: 'Plum', primary: '#2c1a3d', accent: '#a855f7' },
  { name: 'Ocean', primary: '#0f172a', accent: '#0ea5e9' },
  { name: 'Minimal', primary: '#1e293b', accent: '#64748b' },
];

const ThemeCustomizer = ({ theme, onUpdate, onClear }) => (
  <div className="theme-customizer">
    <div className="customizer-header">
      <h2>Appearance</h2>
      <button className="clear-form-button" onClick={onClear}>Clear All</button>
    </div>

    <div className="customizer-body">
      {/* Color Presets */}
      <div className="option-group">
        <label>Color Scheme</label>
        <div className="color-presets">
          {colorPresets.map(p => (
            <button
              key={p.name}
              className={`color-preset-btn ${theme.primaryColor === p.primary && theme.accentColor === p.accent ? 'active' : ''}`}
              onClick={() => onUpdate({ ...theme, primaryColor: p.primary, accentColor: p.accent })}
              title={p.name}
            >
              <span className="preset-swatch" style={{ background: p.accent }} />
              <span className="preset-name">{p.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Custom Colors */}
      <div className="option-group-row">
        <div className="option-group">
          <label>Primary Color</label>
          <div className="color-input-group">
            <input type="color" value={theme.primaryColor}
              onChange={(e) => onUpdate({ ...theme, primaryColor: e.target.value })}
              className="color-picker" />
            <span className="color-hex">{theme.primaryColor}</span>
          </div>
        </div>
        <div className="option-group">
          <label>Accent Color</label>
          <div className="color-input-group">
            <input type="color" value={theme.accentColor}
              onChange={(e) => onUpdate({ ...theme, accentColor: e.target.value })}
              className="color-picker" />
            <span className="color-hex">{theme.accentColor}</span>
          </div>
        </div>
      </div>

      {/* Font & Typography */}
      <div className="option-group-row">
        <div className="option-group">
          <label>Font Family</label>
          <select value={theme.font} onChange={(e) => onUpdate({ ...theme, font: e.target.value })}>
            {fonts.map(f => (
              <option key={f} value={f} style={{ fontFamily: f }}>{f}</option>
            ))}
          </select>
        </div>
        <div className="option-group">
          <label>Font Size</label>
          <select value={theme.fontSize} onChange={(e) => onUpdate({ ...theme, fontSize: e.target.value })}>
            {fontSizes.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </div>

      {/* Line Height */}
      <div className="option-group">
        <label>Line Height: {theme.lineHeight}</label>
        <input type="range" min="1.2" max="2.0" step="0.1" value={parseFloat(theme.lineHeight)}
          onChange={(e) => onUpdate({ ...theme, lineHeight: e.target.value })} />
      </div>

      {/* Section Spacing */}
      <div className="option-group">
        <label>Section Spacing: {theme.sectionSpacing}</label>
        <input type="range" min="16" max="40" step="2" value={parseInt(theme.sectionSpacing)}
          onChange={(e) => onUpdate({ ...theme, sectionSpacing: e.target.value + 'px' })} />
      </div>
    </div>
  </div>
);

export default ThemeCustomizer;
